var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 78,
    viewBox: "0 0 53 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0956 78C38.9241 78 49.3236 76.8445 49.3236 75.4191C49.3236 73.9938 38.9241 72.8383 26.0956 72.8383C13.2672 72.8383 2.86768 73.9938 2.86768 75.4191C2.86768 76.8445 13.2672 78 26.0956 78Z",
    fill: "#9888B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1912 26.0386C52.1912 46.5387 35.3182 61.9379 28.7073 67.1845C27.1713 68.4034 24.9987 68.4112 23.4499 67.2087C16.816 62.0576 0 46.9406 0 26.0386C0 11.6578 11.6834 0 26.0958 0C40.5081 0 52.1916 11.6578 52.1916 26.0386H52.1912Z",
    fill: "url(#paint0_linear_1_1921)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0958 45.3644C36.7926 45.3644 45.4641 36.7119 45.4641 26.0386C45.4641 15.3652 36.7926 6.71277 26.0958 6.71277C15.399 6.71277 6.72754 15.3652 6.72754 26.0386C6.72754 36.7119 15.399 45.3644 26.0958 45.3644Z",
    fill: "#AEAFE3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1921",
    x1: 26,
    y1: -11,
    x2: 26.0958,
    y2: 68.1047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7351",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583095",
    stopOpacity: 0.79
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.6431f2c18e95acba0dcc0aa42d828035.svg";
export { ForwardRef as ReactComponent };